(function () {
  const PATTERN = /\[\[i:([a-z0-9_-]+)\]\]/gi;
  const BLOCKED_TAGS = new Set([
    'SCRIPT',
    'STYLE',
    'TEMPLATE',
    'NOSCRIPT',
    'SVG',
    'CANVAS',
    'IFRAME',
    'OBJECT',
    'EMBED',
    'A',
    'TEXTAREA',
    'INPUT',
    'SELECT',
    'OPTION',
    'CODE',
    'PRE',
  ]);

  function buildKeyMap() {
    const map = new Map();
    document.querySelectorAll('template[data-tooltip-key]').forEach((tpl) => {
      const key = tpl.dataset.tooltipKey.trim().toLowerCase();
      if (key) map.set(key, tpl);
    });
    return map;
  }

  function collectMatches(keyMap) {
    const matches = [];
    const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        const parent = node.parentElement;
        if (!parent) return NodeFilter.FILTER_REJECT;
        if (BLOCKED_TAGS.has(parent.tagName)) return NodeFilter.FILTER_REJECT;
        if (!PATTERN.test(node.nodeValue)) return NodeFilter.FILTER_SKIP;
        PATTERN.lastIndex = 0;
        return NodeFilter.FILTER_ACCEPT;
      },
    });

    let node;
    while ((node = walker.nextNode())) {
      PATTERN.lastIndex = 0;
      let match;
      while ((match = PATTERN.exec(node.nodeValue)) !== null) {
        const key = match[1].toLowerCase();
        if (keyMap.has(key)) {
          matches.push({ node, key, match: match[0], index: match.index });
        }
      }
    }

    return matches;
  }

  function injectTooltips(matches, keyMap) {
    const byNode = new Map();
    for (const m of matches) {
      if (!byNode.has(m.node)) byNode.set(m.node, []);
      byNode.get(m.node).push(m);
    }

    for (const [textNode, nodeMatches] of byNode) {
      nodeMatches.sort((a, b) => b.index - a.index);

      let current = textNode;
      for (const { key, match, index } of nodeMatches) {
        const after = current.splitText(index + match.length);
        const placeholder = current.splitText(index);

        const tpl = keyMap.get(key);
        const clone = tpl.content.cloneNode(true);
        const trigger = clone.querySelector('[data-tooltip-trigger]');

        placeholder.parentNode.replaceChild(clone, placeholder);

        if (trigger) initTooltip(trigger);

        current = after;
      }
    }
  }

  function initTooltip(trigger) {
    // Desktop tooltips now use CSS (group-hover/group-focus-within) for hover/focus behavior
    // Mobile tooltips use modal web components for click behavior

    // Prevent modal interactions from bubbling to parent elements (e.g., accordion triggers)
    const modalContext = trigger.querySelector('modal-context');
    if (modalContext) {
      // Stop propagation on open trigger
      const openTrigger = trigger.querySelector('modal-trigger[action="toggle"]');
      if (openTrigger) {
        openTrigger.addEventListener('click', (e) => {
          e.stopPropagation();
        });
      }

      // Stop propagation on close trigger
      const closeTrigger = modalContext.querySelector('modal-trigger[action="close"]');
      if (closeTrigger) {
        closeTrigger.addEventListener('click', (e) => {
          e.stopPropagation();
        });
      }

      // Stop propagation on backdrop clicks
      const backdrop = modalContext.querySelector('modal-backdrop');
      if (backdrop) {
        backdrop.addEventListener('click', (e) => {
          e.stopPropagation();
        });
      }
    }
  }

  const keyMap = buildKeyMap();
  if (keyMap.size > 0) {
    const matches = collectMatches(keyMap);
    if (matches.length > 0) injectTooltips(matches, keyMap);
  }
})();
